// utils.js
export const formatValText = (val) => {
  if (val == null || val === 0) return '0';
  const isNegative = val < 0;
  const absVal = Math.abs(val);
  let str = '';
  if (absVal >= 10000000) {
    str = `₹${(absVal / 10000000).toFixed(2)} Cr`;
  } else if (absVal >= 100000) {
    str = `₹${(absVal / 100000).toFixed(2)} L`;
  } else {
    str = `₹${absVal.toLocaleString('en-IN')}`;
  }
  return isNegative ? `-${str}` : str;
};


export const formatDashboardTitle = (name) =>
  name
    ?.toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase()) || "Dashboard Detail";


const getPLCategoryOption = (plCategoryData = []) => ({
  tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, textStyle: { fontSize: 14 }, valueFormatter: (value) => formatValText(value) },
  grid: { left: '2%', right: '12%', bottom: '5%', top: '5%', containLabel: false },
  xAxis: { 
    type: 'value', 
    show: false,
    min: (value) => value.min < 0 ? value.min * 1.2 : value.min
  },
  yAxis: {
    type: 'category',
    data: plCategoryData.map(d => d.name),
    axisLine: { show: true, lineStyle: { color: '#cbd5e1' } },
    axisTick: { show: false },
    axisLabel: { color: '#475569', fontSize: 12, margin: 38 }
  },
  series: [
    {
      type: 'bar',
      barWidth: 20,
      data: plCategoryData.map(d => ({
        value: d.Monthly_Actuals_Grand_Total !== undefined ? d.Monthly_Actuals_Grand_Total : d.value,
        label: {
          show: true,
          position: d.value > 0 ? 'right' : 'left',
          formatter: d.labelText,
          color: d.value > 0 ? '#3b82f6' : '#22c55e',
          fontSize: 13,
          distance: 10
        },
        itemStyle: {
          color: d.value > 0 ? '#3b82f6' : '#22c55e',
          borderRadius: d.value > 0 ? [0, 4, 4, 0] : [4, 0, 0, 4]
        }
      }))
    }
  ]
});


const getBUNetPLOption = (data = []) => ({
  tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, textStyle: { fontSize: 14 }, valueFormatter: (value) => formatValText(value) },
  legend: { bottom: 0, left: 10, itemWidth: 12, itemHeight: 12, textStyle: { fontSize: 13, color: '#64748b' } },
  grid: { left: '3%', right: '4%', bottom: '15%', top: '10%', containLabel: true },
  xAxis: {
    type: 'category',
    data: data.map(d => d.Month_Year || d.month_year),
    axisLine: { lineStyle: { color: '#cbd5e1' } },
    axisTick: { show: false },
    axisLabel: { color: '#475569', fontSize: 14, margin: 12 }
  },
  yAxis: {
    type: 'value',
    splitLine: { lineStyle: { color: '#f1f5f9' } },
    axisLabel: {
      color: '#94a3b8',
      fontSize: 12,
      formatter: (value) => formatValText(value)
    }
  },
  series: [
    {
      name: 'SE KPS',
      type: 'bar',
      barWidth: 20,
      itemStyle: { color: '#3b82f6' },
      data: data.map(d => d['SE KPS'] || 0)
    },
    {
      name: 'SE OP (Paid O&M)',
      type: 'bar',
      barWidth: 20,
      itemStyle: { color: '#ea580c' },
      data: data.map(d => d['SE OP'] || 0)
    },
    {
      name: 'SE WH',
      type: 'bar',
      barWidth: 20,
      itemStyle: { color: '#22c55e' },
      data: data.map(d => d['SE WH'] || 0)
    }
  ]
});


const getFCPlanHeadOption = (data = []) => ({
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, textStyle: { fontSize: 14 }, valueFormatter: (value) => formatValText(value) },
    grid: { left: '2%', right: '12%', bottom: '5%', top: '5%', containLabel: true },
    xAxis: { 
      type: 'value', 
      show: false,
      min: (value) => value.min < 0 ? value.min * 1.2 : value.min
    },
    yAxis: {
      type: 'category',
      data: data.map(d => d.Description || d.name),
      axisLine: { show: true, lineStyle: { color: '#cbd5e1' } },
      axisTick: { show: false },
      axisLabel: { color: '#475569', fontSize: 13, margin: 12 }
    },
    series: [
      {
        type: 'bar',
        barWidth: 14,
        data: data.map(d => {
          const val = d.Monthly_Actuals_Grand_Total !== undefined ? d.Monthly_Actuals_Grand_Total : d.value;
          return {
            value: val,
            label: {
              show: true,
              position: val > 0 ? 'right' : 'left',
              formatter: () => formatValText(val),
              color: val > 0 ? '#3b82f6' : '#ef4444',
              fontSize: 12,
              distance: 10
            },
            itemStyle: {
              color: val > 0 ? '#3b82f6' : '#ef4444',
              borderRadius: val > 0 ? [0, 4, 4, 0] : [4, 0, 0, 4]
            }
          };
        })
      }
    ]
  });


const getBUNetFCOption = (data = []) => ({
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, textStyle: { fontSize: 14 }, valueFormatter: (value) => formatValText(value) },
    legend: { bottom: 0, left: 10, itemWidth: 12, itemHeight: 12, textStyle: { fontSize: 13, color: '#64748b' } },
    grid: { left: '3%', right: '4%', bottom: '15%', top: '10%', containLabel: true },
    xAxis: {
      type: 'category',
      data: data.map(d => d.Month_Year || d.month_year),
      axisLine: { lineStyle: { color: '#cbd5e1' } },
      axisTick: { show: false },
      axisLabel: { color: '#475569', fontSize: 14, margin: 12 }
    },
    yAxis: {
      type: 'value',
      splitLine: { lineStyle: { color: '#f1f5f9' } },
      axisLabel: {
        color: '#94a3b8',
        fontSize: 12,
        formatter: (value) => formatValText(value)
      }
    },
    series: [
      {
        name: 'KPS',
        type: 'bar',
        barWidth: 20,
        itemStyle: { color: '#3b82f6' },
        data: data.map(d => d.Monthly_Actuals_KPS || 0)
      },
      {
        name: 'Paid O&M',
        type: 'bar',
        barWidth: 20,
        itemStyle: { color: '#ea580c' },
        data: data.map(d => d.Monthly_Actuals_Paid_OM || 0)
      },
      {
        name: 'Warehouse',
        type: 'bar',
        barWidth: 20,
        itemStyle: { color: '#22c55e' },
        data: data.map(d => d.Monthly_Actuals_Warehouse || 0)
      }
    ]
  });


export { getPLCategoryOption, getBUNetPLOption, getFCPlanHeadOption, getBUNetFCOption };
